<template>
	<div id="">
		<div class="list_ma">
			<div class="list_box p_flex p_f_a p_b_b" v-for="(item, index) in count" :key="index" @click="goDeatils(index)" infinite-scroll-disabled="disabled">
				<div class="p_m_l_60 p_f_1">
					<div>
						<div class="p_flex p_f_a ">
							<span class="type_size_18">{{ item.type_def }}</span>
							<span class="p_m_l_30">{{ item.create_time }}</span>
						</div>
						<span class="p_m_t_14 one-overflow type_size_16">{{ item.content }}</span>
					</div>
				</div>
			</div>
		</div>
		<pagination @get="get" :index="num" />
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue';
export default {
	data() {
		return {
			count: [],
			loading: false,
			num: 0
		};
	},
	components: {
		pagination
	},
	created() {
		this.get();
	},
	mounted() {},
	methods: {
		get(id) {
			this.$request
				.ajax(this)
				.post('/api_teacher/news_other_list', {
					page: id ? id : 1, //第几页
					limit: 10
				})
				.then(res => {
					// console.log(res)
					this.num = parseInt(res.data.length);
					this.count = res.data.list;
				});
		},
		goDeatils(i) {
			if (i == 1) {
				this.$router.push('/Rest');
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
}
.list_ma {
	margin: 0 260px 50px;
}
.list_img {
	width: 60px;
	height: 60px;
}
>>> .el-badge__content {
	background-color: #f1282e;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/news/commponents/restList.vue